(() => {
  const init = root => {
    if (!root || root.dataset.urReady === 'true') return;
    const track = root.querySelector('[data-ur-track]');
    const previous = root.querySelector('[data-ur-prev]');
    const next = root.querySelector('[data-ur-next]');
    const position = root.querySelector('[data-ur-position]');
    if (!track || !previous || !next) return;
    root.dataset.urReady = 'true';
    const cards = [...track.querySelectorAll('.ur-card')];
    const pad = value => String(value).padStart(2, '0');
    const update = () => {
      if (!position || !cards.length) return;
      const left = track.scrollLeft;
      const active = cards.reduce((best, card, index) => Math.abs(card.offsetLeft - left) < best.distance ? { index, distance: Math.abs(card.offsetLeft - left) } : best, { index: 0, distance: Infinity }).index;
      position.textContent = `${pad(active + 1)} / ${pad(cards.length)}`;
      previous.disabled = active === 0;
      next.disabled = active === cards.length - 1;
    };
    const step = direction => {
      const card = track.querySelector('.ur-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).gap) || 24;
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  };
  const initAll = scope => (scope || document).querySelectorAll('.ur-reference').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll()) : initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
